exports.isatty = function () {};
exports.setRawMode = function () {};



//////////////////
// WEBPACK FOOTER
// (webpack)/~/node-libs-browser/mock/tty.js
// module id = 1914
// module chunks = 0